import { Link, useNavigate } from 'react-router-dom';
import { Product } from '@/mocks/products';
import { useScrollReveal } from '@/hooks/useScrollReveal';

interface FeaturedProductsProps {
  products: Product[];
}

const FeaturedProducts = ({ products }: FeaturedProductsProps) => {
  const navigate = useNavigate();
  const featured = products.slice(0, 8);
  const { ref: titleRef, visible: titleVisible } = useScrollReveal(0.1);
  const { ref: gridRef, visible: gridVisible } = useScrollReveal(0.05);

  return (
    <section className="py-20 bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div
          ref={titleRef}
          className={`flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4 transition-all duration-700 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div>
            <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold px-3 py-1 rounded-full mb-3 uppercase tracking-wider">
              İkinci El Ürünler
            </span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900">
              Seçili Ürünler
            </h2>
          </div>
          <Link
            to="/ikinci-el"
            className="flex items-center gap-2 text-orange-500 hover:text-orange-600 font-semibold text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Tümünü Gör
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((product, i) => (
            <div
              key={product.id}
              onClick={() => navigate(`/urun/${product.id}`)}
              className={`bg-white rounded-xl overflow-hidden border border-slate-100 hover:scale-[1.03] hover:-translate-y-1 transition-all duration-500 group cursor-pointer ${gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: gridVisible ? `${i * 70}ms` : '0ms' }}
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 bg-orange-500 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
                  {product.category}
                </span>
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <div className="p-4">
                <h3 className="font-bold text-slate-900 text-sm mb-1 line-clamp-2">{product.name}</h3>
                <p className="text-slate-500 text-xs leading-relaxed mb-3 line-clamp-2">{product.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xl font-extrabold text-orange-500">
                    {product.price.toLocaleString('tr-TR')} ₺
                  </span>
                  <span className="bg-slate-900 group-hover:bg-orange-500 text-white text-xs px-3 py-1.5 rounded-lg transition-colors duration-300 whitespace-nowrap">
                    İncele
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
